import { Link, useParams } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";

export default function ThankYou() {
  const { slug } = useParams();
  const topic = (slug || "").replace(/^thank-you-/, "").replace(/-/g, " ").trim();
  useSEO({ title: "Thank You | Training Basket", noindex: true });

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-slate-50 px-4" data-testid="thank-you-page">
      <div className="max-w-md w-full bg-white rounded-3xl border border-slate-200 shadow-sm p-10 text-center">
        <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
        <h1 className="text-2xl font-extrabold text-[#17263B] tracking-tight mt-5" data-testid="thank-you-heading">
          Thank you!
        </h1>
        <p className="text-sm text-slate-500 mt-3 leading-relaxed">
          {topic
            ? `Your enquiry about the ${topic} program has been received. Our counsellor will reach out to you shortly.`
            : "Your enquiry has been received. Our counsellor will reach out to you shortly."}
        </p>
        <div className="flex flex-col gap-2.5 mt-7">
          <Link to="/" data-testid="thank-you-home"
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-rose-600 hover:bg-rose-700 text-white font-bold px-6 py-3 text-sm transition-colors">
            Back to Home <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/courses" data-testid="thank-you-courses"
            className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-slate-200 text-[#17263B] hover:border-slate-300 font-bold px-6 py-3 text-sm transition-colors">
            Browse Programs
          </Link>
        </div>
      </div>
    </div>
  );
}
